import styled, { css } from 'styled-components';

export const Element = styled.div`
  ${() => {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: stretch;

      gap: 1rem;

      margin-top: 1rem;

      a {
        text-decoration: underline;
      }
    `;
  }};
`;

export const PriceContainer = styled.div`
  ${() => {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: center;

      flex-grow: 1;

      sup {
        font-size: 0.75rem;
        top: -1rem;
      }
    `;
  }};
`;

export const TravelTypeBadge = styled.div`
  //
`;

export const PackageAttributes = styled.div`
  ${({ theme }) => {
    return css`
      border: 1px solid ${theme.color.neutral_200};
      border-radius: ${theme.radius.xs};
      width: 100%;
      padding: 1rem;
    `;
  }};
`;
